import { INITIALIZE_AUTH, UPDATE_GATES } from '../actions/constants/ActionTypes';
const initialState = {
  user: {},
  portal: {},
  gates: []
};
const auth = (state = initialState, action) => {
  const {
    type,
    payload
  } = action;
  let authPayload;
  switch (type) {
    case INITIALIZE_AUTH:
      authPayload = payload;
      return {
        user: authPayload.user,
        gates: authPayload.gates,
        portal: authPayload.portal
      };
    case UPDATE_GATES:
      return Object.assign({}, state, {
        gates: payload
      });
    default:
      return state;
  }
};
export default auth;